// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"e6073e42","230":"e6073e42","348":"e6073e42","693":"e6073e42"}[chunkId] + ".chunk.css";
};